"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roleToString = exports.isOwner = exports.isClientAccount = exports.canApprove = exports.CompanyUserRole = void 0;
var CompanyUserRole;
(function (CompanyUserRole) {
    CompanyUserRole["OWNER"] = "owner";
    CompanyUserRole["MEMBER"] = "member";
    CompanyUserRole["CLIENT_ACCOUNT"] = "client_account";
})(CompanyUserRole || (exports.CompanyUserRole = CompanyUserRole = {}));
const canApprove = (role) => role === CompanyUserRole.OWNER || role === CompanyUserRole.CLIENT_ACCOUNT;
exports.canApprove = canApprove;
const isClientAccount = (role) => role === CompanyUserRole.CLIENT_ACCOUNT;
exports.isClientAccount = isClientAccount;
const isOwner = (role) => role === CompanyUserRole.OWNER;
exports.isOwner = isOwner;
exports.roleToString = {
    [CompanyUserRole.OWNER]: "Owner",
    [CompanyUserRole.MEMBER]: "Member",
    [CompanyUserRole.CLIENT_ACCOUNT]: "Client Account",
};
